<div
  class="card card-custom"
  [ngClass]="{ 'card-body-progress card-body-progress-overlay': viewLoading }"
>
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">{{ 'AGREEMENT.REVOKE_AGREEMENT.TITLE' | translate }}</h3>
    </div>
  </div>
  <div style="min-height: 200px !important" class="card-body pt-15">
    <div class="card-body-progress">
      <mat-spinner [diameter]="5"></mat-spinner>
    </div>
    <div *ngIf="viewLoading">{{ 'AGREEMENT.REVOKE_AGREEMENT.WAIT_DESCRIPTION' | translate }}</div>
    <div *ngIf="!viewLoading">
      <form [formGroup]="form" class="form form-group mb-0">
        <p>Please provide a short description for why this agreement is being revoked.</p>
        <div class="mb-2">
          <div class="mb-2">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label>Reason</mat-label>
              <input matInput formControlName="reason" required />
              <mat-error *ngIf="form.controls['reason'].hasError('required')">
                Reason is required
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div
    tabindex="0"
    class="card-footer d-flex justify-content-end"
    (keydown.enter)="onEnterKey($event)"
  >
    <button
      #cancelButton
      mat-raised-button
      cdkFocusInitial
      style="width: 100px !important"
      class="btn btn-sm btn-light"
      (click)="onNoClick()"
    >
      {{ 'GLOBAL.CANCEL' | translate }}
    </button>
    <button
      #confirmButton
      mat-raised-button
      [disabled]="viewLoading"
      style="width: 100px !important"
      class="btn btn-sm btn-primary ml-4"
      (click)="onYesClick()"
    >
      {{ 'GLOBAL.CONFIRM' | translate }}
    </button>
  </div>
</div>
